/** Espacement par défaut des grilles de Bloc (= md Mantine, 16 px). */
export const DEFAULT_SECTION_GAP_CSS = '1rem';

/**
 * Gap effectif d'un Bloc : prop absente (sections du parser / antérieures
 * au champ) → défaut 16 px ; chaîne vide (champ vidé par l'utilisateur)
 * → 0 ; sinon la longueur CSS stockée.
 */
export function resolveSectionGap(gap) {
  if (gap == null) return DEFAULT_SECTION_GAP_CSS;
  return gap === '' ? 0 : gap;
}
